import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import Box from './box';
import Demo from './demo/demo';
import Image from '../../../components/image';

//images
import IconTrace from '../../../images/icon-trace.png';
import IconAgile from '../../../images/icon-agile.png';
import IconSustainable from '../../../images/icon-sustainable.png';

import Title from '../../elements/title';
import Lottie from 'lottie-react-web';
import dataSecurity from './dataSecurity.json';
import './mission.scss';
const Mission = () => {
	return (
		<>
			<section className='section-padding' id='mission'>
				<Container>
					<Title
						label='Mission'
						title='Die Zukunft der Produktsicherheit'
						subtitle='Wir haben genug von zeitaufwendigen und fehleranfälligen Prozessen
							in der Produktsicherheit. Getrieben von dem Ziel eines
							umweltbewussten und zukunftsfähigen Wirtschaftens haben wir als
							Unternehmer nur eine Wahl – durch Automatisierung und
							Digitalisierung den notwendigen Fortschritt selber zu gestalten.'
						darkBackground
					/>
					<div className='mission-row'>
						<Row>
							<div className='circle'></div>
							<Col md={3} lg={4}></Col>

							<Col md={6} lg={4} className='col-mid'>
								<Box
									title={
										<>
											<span>Sus</span>tainable
										</>
									}
									text='Indem wir Transparenz entlang der Lieferkette und Agilität im Handeln
				ermöglichen, leisten wir einen Beitrag zur Entwicklung nachhaltiger
				Produkte in der chemischen Industrie.'
									icon={IconSustainable}
								/>
							</Col>
							<Col md={3} lg={4}></Col>
						</Row>
						<Row>
							<Col md={0} lg={1}></Col>

							<Col md={6} lg={4}>
								<Box
									title={
										<>
											<span>Tra</span>ceable
										</>
									}
									text='Wir vereinfachen und standardisieren den Informationsaustausch entlang der Lieferkette und ermöglichen damit die lückenlose Nachverfolgbarkeit von Produktinhaltstoffen.'
									icon={IconTrace}
								/>
							</Col>
							<Col className='d-none d-lg-inline-block' md={0} lg={2}></Col>

							<Col md={6} lg={4}>
								<Box
									title={
										<>
											<span>Agil</span>e
										</>
									}
									text='Die jederzeit und überall verfügbare
							Informationsbasis befähigt Sie, proaktiv auf Anforderungen zu reagieren, um langfristig handlungsfähig zu bleiben.'
									icon={IconAgile}
								/>
							</Col>
						</Row>
					</div>
				</Container>
				<div className='lines'>
					<Container>
						<div className='lottie-security'>
							<Lottie
								width='100%'
								speed={0.5}
								options={{
									animationData: dataSecurity,
								}}
							/>
						</div>
						<Title
							title='Hohe Datensicherheit'
							subtitle='Ihre Datensicherheit hat für uns höchste Priorität. Daher liegen
						Ihre Daten geschützt und cloudbasiert in Europa. Nur Sie
						entscheiden, was mit diesen passiert und welche Informationen Sie,
						wann und mit wem teilen möchten.'
							darkBackground
						/>
					</Container>
				</div>
			</section>
			<Container>
				<Demo />
			</Container>
		</>
	);
};

export default Mission;
